module.exports = __webpack_public_path__ + "static/media/index.451acb54.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Ellipsis/index.less
// module id = 1052
// module chunks = 0